import React from "react";
import Select from "react-select";
import "react-select/dist/react-select.css";

class ReactSelect extends React.Component {

  render() {
    const { allOptions,selectedOption,filedKey } = this.props;
    return (
      <Select
        clearable={false}
        value={selectedOption}
        onChange={(e)=> this.props.handleChange(e,filedKey)}
        options={allOptions}
      />
    );
  }
}

export default ReactSelect;


// WEBPACK FOOTER //
// ./src/views/AssetSchemas/AssetSchemas/AddSchema/Select.js